export default __webpack_public_path__ + "static/media/food1.50b25da9.png";